import { useDeleteOrderItemMutation, useGetEventQuery, useGetLocationSchemeQuery, useGetOrderItemsMutation, useGetOrderMutation, useGetSessionAssignmentsQuery, useGetSessionQuery, useGetSesssionPriceCategoriesQuery, usePostBasketClearMutation, usePostOrderItemMutation, usePostOrderMutation } from "../../features/CallTPApi"
import { useParams } from "react-router"
import { LoadingLogo } from "../UI/Loading"
import { Badge, Button, Container, OverlayTrigger, Popover, Spinner } from "react-bootstrap"
import { ISession } from "../../interface/ISession"
import { format } from "date-fns"
import { ru } from "date-fns/locale"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { setlocationSchemeInStore } from "../../features/locationSchemeSlice"
import { useSelector } from "react-redux"
import { ILocation } from "../../interface/ILocation"
import { ICategoryAssignments } from "../../interface/ICategoryAssignments"
import { shallowEqual } from "react-redux"
import { setBasketInStore } from "../../features/basketSlice"
import { ICursorPos } from "../../interface/ICursorPos"
import { setSessionAssignmentsStore } from "../../features/sessionAssignmentsSlice"
import { IOrder } from "../../interface/IOrder"
import { setAlertMsgStore } from "../../features/alertMsgSlisce"
import { setOrderInStore } from "../../features/orderSlice"
import { IOrderItems } from "../../interface/IOrderItem"
import { ArrowLeftCircleFill, InfoCircle } from "react-bootstrap-icons"
import { NumericFormat } from 'react-number-format';
import { setSessionItemsInStore } from "../../features/sessionItemsSlice"
import { setSessionStore } from "../../features/sessionSlice"
import { FullScreenLoader } from "../UI/FullScreenLoader"
import { setEventStore } from "../../features/eventSlice"
import { setCategoresSessionStore } from "../../features/categoresSessionSlisce"
import { IBasket } from "../../interface/IBasket"
import { setCategoryPriceStore } from "../../features/categoryPriceSlisce"
import { PayPanel } from "./PayPanel"
import { IDistributor } from "../../interface/IDistributor"
import { MainStage } from "../Scheme/MainStage"
import { Helmet } from "react-helmet"
import { useSearchParams } from "react-router-dom"


const DescriptionTooltip = (props: any) => {

    const popover = (
        <Popover id="popover-basic" className="shadow">
            <Popover.Header as="h3" style={{ color: props.dataCategory.color }}>{props.dataCategory.seatcategory.name}</Popover.Header>
            <Popover.Body className="p-2">
                <strong>
                    {props.dataCategory.description}
                </strong>
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={['click', 'hover']} placement="bottom" overlay={popover}>
            <InfoCircle />
            {/* <Button variant="success">Click me to see</Button> */}
        </OverlayTrigger>
    )
}

const CategoryBadge = ({ category }: { category: any }) => {
    const categoryPrice = useSelector((state: any) => state.categoryPrice, shallowEqual) as any[];
    const [dataCategory, setDataCategory] = useState<any>(null)

    useEffect(() => {
        if (categoryPrice) {
            const data = categoryPrice.find((item: any) => item.id === category.id)
            setDataCategory(data)
        }
    }, [categoryPrice])

    return (
        <div key={category.id} className="d-flex justify-content-center align-items-center pt-1 pb-1 ps-2 pe-2 border shadow rounded-4 border border-black" style={{ fontSize: "14px" }}>
            <div className="p-1 me-2" style={{ backgroundColor: category.color, height: '20px', width: '20px', borderRadius: '50%' }}></div>
            {/* <div className="p-1 d-none d-lg-block text-nowrap">{item.name}</div> */}
            <div className="p-1 text-nowrap fw-bold">
                <NumericFormat displayType={'text'} value={category.price} allowLeadingZeros thousandSeparator=" " /> ₽
            </div>
            {dataCategory &&
                <DescriptionTooltip dataCategory={dataCategory} />
            }
        </div>
    )
}



const Scheme = ({ session, reqRefetch, setReqRefetch, getOrderInStroe }: { session: ISession, reqRefetch: boolean, setReqRefetch: (state: boolean) => void, getOrderInStroe: () => void }) => {

    const { data: locationData } = useGetLocationSchemeQuery(session.locationId)
    const [postOrderItem, { isLoading: isLoadingPostOrderItem }] = usePostOrderItemMutation()
    const sessionAssignments = useSelector((state: any) => state.sessionAssignments, shallowEqual) as ICategoryAssignments[];
    const sessionCategories = useSelector((state: any) => state.categoresSession, shallowEqual) as any[];
    const basketInStore = useSelector((state: any) => state.basket, shallowEqual);
    var order = useSelector((state: any) => state.order, shallowEqual);
    const [cursorPos, setCursorPos] = useState<ICursorPos | any>({ x: 0, y: 0 })
    const { data: assignmentsData, refetch } = useGetSessionAssignmentsQuery(session.id)
    const [deleteOrderItem, { isLoading: isLoadingDeleteOrderItem }] = useDeleteOrderItemMutation()
    const [postOrder, { isLoading: isLoadingPostOrder }] = usePostOrderMutation()
    const sessionItems = useSelector((state: any) => state.sessionItems, shallowEqual);
    const [soldOut, setSoldOut] = useState<boolean>(false)
    const [getOrderItems, { isLoading: isLoadingOrderItems }] = useGetOrderItemsMutation()

    const dispatch = useDispatch()
    const deleteItems = useSelector((state: any) => state.deleteItems, shallowEqual) as IOrderItems[];

    useEffect(() => {
        if (deleteItems) {
            deleteItems.forEach(async (item: IOrderItems) => {
                await handleDeselect({ id: item.id } as IBasket)
            })
        }
    }, [deleteItems])

    useEffect(() => {
        if ((sessionItems && sessionAssignments)) {
            const newBasketItems = [] as any;
            const newIds = [] as any;
            sessionItems.forEach((item: IOrderItems) => {
                const dataTarget = sessionAssignments.find((cat: ICategoryAssignments) => cat.id === item.priceCategoryAssignmentId) as ICategoryAssignments;
                // console.log(item.quantity < dataTarget.orderItemsQuantity)
                if (!dataTarget) {
                    return;
                }
                if (item.quantity < dataTarget.orderItemsQuantity) {
                    deleteOrderItem(item.id)
                    return;
                }
                const basketItem = {
                    id: dataTarget.targetId,
                    price: dataTarget.price,
                    color: dataTarget.color,
                    quantity: 1,
                    orderId: order.id,
                    priceCategoryAssignmentId: dataTarget.id,
                    itemId: item.id
                } as any;
                newBasketItems.push(basketItem)
                newIds.push(dataTarget.targetId)
            })
            dispatch(setBasketInStore(newBasketItems))
        }
    }, [sessionItems, sessionAssignments])


    useEffect(() => {
        if (reqRefetch) {
            refetch()
            setReqRefetch(false)
        }
    }, [reqRefetch])

    const createOrder = async () => {
        // dispatch(setAlertMsgStore({ title: "Идет создание заказа...", variant: "info" } as any))
        const newOrder = {
            orderNumber: ''
        }
        return await postOrder(newOrder).then((r: any) => {
            // console.log(r)
            if (!r.error) {
                console.log(r)
                localStorage.setItem('order', JSON.stringify(r.data))
                localStorage.setItem('sessionId', session.id as string)
                dispatch(setOrderInStore(r.data))
                // dispatch(setAlertMsgStore({ title: "Заказ успешно создан", variant: "success" } as any))
                return r.data;
            }
        })
    }
    useEffect(() => {
        if (locationData) {
            dispatch(setlocationSchemeInStore(locationData))
        }
        else {
            dispatch(setlocationSchemeInStore(null))
        }
    }, [locationData])
    useEffect(() => {
        if (assignmentsData) {
            dispatch(setSessionAssignmentsStore(assignmentsData))
            const items = assignmentsData.filter((item: any) => item.orderItemsQuantity < item.limit)
            if (items.length === 0) {
                setSoldOut(true)
            }
            const assignments = assignmentsData
                .map((item: ICategoryAssignments) => ({
                    name: item.name,
                    color: item.color,
                    price: item.price,
                    id: item.priceCategoryId,
                    description: "TEST"
                }))
                .filter((item: any, index: any, self: any) =>
                    index === self.findIndex((t: any) => (
                        t.name === item.name && t.color === item.color && t.price === item.price
                    ))
                )
                .sort((a: any, b: any) => a.price - b.price);

            console.log(assignments);

            dispatch(setCategoresSessionStore(assignments))
        }
    }, [assignmentsData])

    const handleSelect = async (selectItem: IBasket) => {
        var orderId = order?.id;
        if (!order) {
            const newOrder = await createOrder()
            orderId = newOrder.id;
        }
        const dataTarget = sessionAssignments.find((cat: ICategoryAssignments) => cat.targetId === selectItem.id) as ICategoryAssignments;
        if (dataTarget && dataTarget.groupTag) {
            const groupSeats = sessionAssignments.filter((item: ICategoryAssignments) => item.groupTag === dataTarget.groupTag).map(
                (item) => {
                    return {
                        orderId: orderId,
                        priceCategoryAssignmentId: item.id,
                        quantity: 1,
                        fiscalData: '',
                    } as IOrderItems
                }
            )
            await Promise.all(
                groupSeats.map((seat) => {
                    return postOrderItem(seat as any).unwrap();
                })
            );
            getOrderItems(orderId).then((r: any) => {
                if (!r?.error) {
                    const items = r.data
                    // setSessionItems(items)
                    dispatch(setSessionItemsInStore(items as any))

                    // console.log(items)
                }
                if (r?.error) {
                    localStorage.removeItem('order')
                    localStorage.removeItem('sessionId')
                    dispatch(setOrderInStore(null as any))
                }
            })
            return;
            // console.log(groupSeats)
        }
        else {
            const formBody = {
                orderId: orderId,
                priceCategoryAssignmentId: dataTarget.id,
                quantity: 1,
                fiscalData: '',
            } as IOrderItems;
            postOrderItem(formBody).then((r: any) => {
                if (!r.error) {
                    getOrderItems(orderId).then((r: any) => {
                        if (!r?.error) {
                            const items = r.data
                            // setSessionItems(items)
                            dispatch(setSessionItemsInStore(items as any))

                            // console.log(items)
                        }
                        if (r?.error) {
                            localStorage.removeItem('order')
                            localStorage.removeItem('sessionId')
                            dispatch(setOrderInStore(null as any))
                        }
                    })
                }
                else {
                    refetch()
                    getOrderInStroe()
                }
            })
        }
    }
    const handleDeselect = async (selectItem: IBasket) => {
        const itemInStore = basketInStore.find((item: any) => item.id === selectItem.id) as any
        const itemGroup = sessionAssignments.find((item) => item.targetId === itemInStore.id)
        if (itemGroup && itemGroup.groupTag) {
            const itemsGroup = sessionAssignments.filter((item: any) => item.groupTag === itemGroup.groupTag) as any
            console.log(itemsGroup)
            console.log(basketInStore)
            const deleteItems = itemsGroup.map((item: any) => {
                const delItem = basketInStore.find((itemBasket: any) => itemBasket.id === item.targetId)
                return delItem
            })
            console.log(deleteItems)

            await Promise.all(
                deleteItems.map((seat: any) => {
                    return deleteOrderItem(seat.itemId as any).unwrap();
                })
            );
            getOrderItems(order.id).then((r: any) => {
                if (!r?.error) {
                    const items = r.data
                    dispatch(setSessionItemsInStore(items as any))
                }
                if (r?.error) {
                    localStorage.removeItem('order')
                    localStorage.removeItem('sessionId')
                    dispatch(setOrderInStore(null as any))
                }
            })
            return;
        }
        else {
            await deleteOrderItem(itemInStore.itemId).then((r: any) => {
                if (!r.error) {
                    getOrderItems(order.id).then((r: any) => {
                        if (!r?.error) {
                            const items = r.data
                            // setSessionItems(items)
                            dispatch(setSessionItemsInStore(items as any))

                            // console.log(items)
                        }
                        if (r?.error) {
                            localStorage.removeItem('order')
                            localStorage.removeItem('sessionId')
                            dispatch(setOrderInStore(null as any))
                        }
                    })
                }
                else {
                    const error = r.error as any;
                    const message = error.data
                    dispatch(setAlertMsgStore({ title: `Ошибка при удалении места из корзины ${message}`, variant: "danger" } as any))
                    refetch()
                    getOrderInStroe()
                }
            })
        }
    };

    return (
        <>
            {/* <div className="position-relative"> */}
            {/* <div className="position-absolute bg-dark" style={{ top: 10, left: 10, zIndex: 2001 }}> */}
            {sessionCategories &&
                <div className="d-flex pb-2 gap-1 w-100 text-nowrap" style={{ overflowY: 'hidden', overflowX: 'auto' }}>
                    <Button onClick={() => {
                        window.history.back()
                    }}
                        className="d-md-flex p-1 rounded-4 pe-2 d-none shadow border border-1"
                        style={{ alignItems: 'center' }}
                        variant="light"
                    ><ArrowLeftCircleFill className="me-2 ms-1" />К выбору сеанса</Button>
                    <div className="d-flex gap-1 w-100 text-nowrap flex-fill">
                        {sessionCategories.map((item: any) =>
                            <CategoryBadge key={item.id} category={item} />
                        )}
                    </div>
                </div>
            }
            {/* </div>
            </div> */}
            {isLoadingOrderItems && <FullScreenLoader message="Обновление состава корзины..." />}

            {isLoadingDeleteOrderItem &&
                <FullScreenLoader message="Удаление места из заказа..." />
            }
            {isLoadingPostOrderItem &&
                <FullScreenLoader message="Добавление места в заказ..." />
            }
            {isLoadingPostOrder &&
                <FullScreenLoader message="Создание заказа..." />
            }
            <div style={{ maxHeight: '100%' }}>
                {sessionAssignments ?
                    <MainStage
                        handleSelect={handleSelect}
                        handleDeselect={handleDeselect}
                        cursorPos={cursorPos}
                        setCursorPos={setCursorPos}
                        soldOut={soldOut}
                    />
                    :
                    <Spinner />}
            </div>
        </>
    )
}

const EventData = ({ session }: { session: ISession }) => {

    const distributor = useSelector((state: any) => state.distributor) as IDistributor
    const { data: event } = useGetEventQuery(session.eventId)
    const location = useSelector((state: any) => state.locationScheme) as ILocation
    const dispatch = useDispatch()
    useEffect(() => {
        if (event) {
            console.log(event)
            dispatch(setEventStore(event as any))
        }
    }, [event])

    return (
        <>
            {event &&
                <Helmet>
                    {/* Основной заголовок */}
                    <title>
                        {event?.name} {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, 'EEEE', { locale: ru })}, {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "dd.MM.yyyy")} {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "HH:mm")} - Tickets Pulse - поймай ритм своих событий!
                    </title>

                    {/* Описание страницы */}
                    {/* {event?.description && (
                        <meta name="description" content={event?.description} />
                    )} */}
                    {/* Язык документа */}
                    <meta http-equiv="Content-Language" content="ru" />
                    {/* Метатег для мобильных устройств */}
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    {/* Автор */}
                    {/* <meta name="author" content="Tickets Pulse" /> */}
                    {/* Open Graph для Facebook, ВКонтакте и т.д. */}
                    {/* {event?.name && (
                        <>
                            <meta property="og:title" content={event.name} />
                            <meta property="og:description" content={event?.description || "Билеты на событие"} />
                            <meta property="og:type" content="website" />
                            <meta property="og:url" content={`https://ticketspulse.ru/events/${event.id}?distributorId=${distributor?.id}`} />
                            <meta property="og:site_name" content="Tickets Pulse" />
                            <meta property="og:image" content={`/api/Events/${event.id}/afishaimage`} />
                        </>
                    )} */}

                    {/* Twitter Card */}
                    {/* {event?.name && (
                        <>
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={event.name} />
                            <meta name="twitter:description" content={event?.description || "Билеты на событие"} />

                            <meta name="twitter:image" content={`/api/Events/${event.id}/afishaimage`} />
                        </>
                    )} */}

                    {/* Canonical URL для избежания дублирования страниц */}
                    <link rel="canonical" href={`https://ticketspulse.ru/events/${event?.id}?distributorId=${distributor?.id}`} />
                </Helmet>
            }
            <Container>
                <div className="d-flex ps-3 pt-3 pe-3">
                    <div className="flex-fill">
                        <div className="d-flex fs-5">
                            <div>
                                <span className="fw-bold">
                                    {event?.name},
                                </span>
                                <Badge bg="dark" className="ms-2"> <b>{event?.ageRating}+</b></Badge>
                            </div>
                        </div>
                        <div className="text-muted fs-6 fw-bold">{location?.ticketName}</div>

                        <div style={{ fontSize: "18px" }}>
                            {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, 'EEEE', { locale: ru })}, {format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "dd.MM.yyyy")} в <b>{format(new Date(session.startTime).getTime() + 3 * 60 * 60 * 1000, "HH:mm")}</b>
                        </div>
                        <div className="text-muted" style={{ fontSize: "13px" }}>
                            Продолжительность: <b>{session.duration} мин.</b>
                        </div>
                        <p className="text-muted" style={{ fontSize: "13px" }}><b>{location?.address}</b></p>
                    </div>
                    {/* <div>
                    {event?.description}
                </div> */}
                </div>
                <div className="mb-3 ms-2 d-md-none" style={{ alignItems: 'center', alignContent: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Button onClick={() => {
                        window.history.back()
                    }}
                        className="d-flex p-1 rounded pe-2 shadow"
                        style={{ alignItems: 'center' }}
                        variant="light"
                    ><ArrowLeftCircleFill className="me-2" />К выбору сеанса</Button>
                </div>
            </Container >
        </>
    )
}

export const PayTicketSession = () => {

    const [responseUrl, setResponseUrl] = useSearchParams();
    const params = useParams()
    const { data: session, isLoading: isLoadingSession } = useGetSessionQuery(responseUrl.get("sessionsId"))
    const { data: categoriesData } = useGetSesssionPriceCategoriesQuery(responseUrl.get("sessionsId"))


    const [getOrder] = useGetOrderMutation()
    // const [sessionItems, setSessionItems] = useState<IOrderItems[]>([]);
    const [reqRefetch, setReqRefetch] = useState<boolean>(false)
    const dispatch = useDispatch()
    const [getOrderItems] = useGetOrderItemsMutation()
    const [postBasketClear] = usePostBasketClearMutation()
    const getOrderInStroe = async () => {
        const orderInStorage = localStorage.getItem('order') as string;
        if (orderInStorage !== undefined && orderInStorage !== null) {
            const order: IOrder = JSON.parse(orderInStorage);
            await getOrder(order.id).then(async (r: any) => {
                if (!r?.error) {
                    if (r.data.orderStatus > 1) {
                        localStorage.removeItem('order')
                        localStorage.removeItem('sessionId')
                        dispatch(setOrderInStore(null as any))
                        return
                    }
                    const createdOrderDate = new Date(r.data.createdDate)
                    if (createdOrderDate.getTime() > new Date().getTime() - 1000 * 60 * 20) {
                        localStorage.removeItem('order')
                        localStorage.removeItem('sessionId')
                        dispatch(setOrderInStore(null as any))
                        return
                    }

                    localStorage.setItem('order', JSON.stringify(r.data))
                    dispatch(setOrderInStore(r.data as any))

                    const sessionId = localStorage.getItem('sessionId') as string;
                    if (session?.id !== sessionId) {
                        await postBasketClear(order.id).then(() => {
                            dispatch(setBasketInStore([] as any))
                            dispatch(setSessionItemsInStore(null as any))
                        })
                        localStorage.setItem('sessionId', session?.id as string)

                    }
                    else {

                        getOrderItems(r.data.id).then((r: any) => {
                            if (!r?.error) {
                                const items = r.data
                                // setSessionItems(items)
                                dispatch(setSessionItemsInStore(items as any))

                                // console.log(items)
                            }
                            if (r?.error) {
                                localStorage.removeItem('order')
                                localStorage.removeItem('sessionId')
                                dispatch(setOrderInStore(null as any))
                            }
                        })
                    }
                }
                if (r?.error) {
                    localStorage.removeItem('order')
                    localStorage.removeItem('sessionId')
                    dispatch(setOrderInStore(null as any))
                }
            })
        }
    }

    useEffect(() => {
    }, [params.id])
    useEffect(() => {
        if (session) {
            dispatch(setSessionStore(session as any))
            getOrderInStroe()
        }
    }, [session])
    useEffect(() => {
        if (categoriesData) {
            dispatch(setCategoryPriceStore(categoriesData))
        }
    }, [categoriesData]);

    useEffect(() => {
        console.log(responseUrl.get("sessionsId"))
    }, [responseUrl])

    return (
        <div className="m-auto">
            {/* <div className="haed-layout-tickets d-none d-lg-block">
                <div className="head-layout-img" style={{ backgroundImage: "url(/Show/091A8332.jpg" }}>
                </div>
                <div className="head-mask"></div>

            </div> */}
            {!isLoadingSession ?
                <>
                    {session &&
                        <>
                            {/* <div> */}
                            <EventData session={session} />
                            {/* </div> */}
                            <Container >
                                <Scheme reqRefetch={reqRefetch} setReqRefetch={setReqRefetch} session={session} getOrderInStroe={getOrderInStroe} />
                            </Container>
                            <PayPanel setReqRefetch={setReqRefetch} getOrderInStroe={getOrderInStroe} />
                        </>
                    }
                </>
                :
                <LoadingLogo />
            }
        </div>
    )
}